import React, { useEffect, useState } from 'react';
import { TextField, CircularProgress, MenuItem } from '@mui/material';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { getBaseCodes } from '../../../../modules/auth';

const SearchCodeSelectbox = ({
  formik,
  name,
  label,
  filterObject,
  variant,
  margin,
  size,
  required,
}) => {
  const [options, setOptions] = useState([]);

  const dispatch = useDispatch();
  const { baseCodes, error, loading } = useSelector(
    ({ auth, loading }) => ({
      baseCodes: auth.baseCodes,
      error: auth.baseCodesError,
      loading: loading['auth/GET_BASECODES'],
    }),
  );

  useEffect(() => {
    if (!baseCodes) {
      dispatch(getBaseCodes());
    } else {
      const filteredList = _.filter(baseCodes, filterObject);
      //console.log(filterObject,filteredList)
      const orderedList = _.orderBy(filteredList, "step");
      setOptions(orderedList);
    }
  }, [dispatch, baseCodes])


  if (loading || !baseCodes) {
    return <CircularProgress color="inherit" size={20} />;
  }

  return (
    <>
      {options.length > 0 ? (
        <TextField
          margin={margin !== null ? margin : ''}
          variant={variant !== null ? variant : 'outlined'}
          required={required}
          fullWidth
          select
          size={size}

          id={name}
          name={name}
          label={label}
          value={formik.values[name] ? formik.values[name] : ''}
          onChange={(event, newValue) => {

            formik.setFieldValue(name, event.target.value);
          }}
          error={formik.touched[name] && Boolean(formik.errors[name])}
          helperText={formik.touched[name] && formik.errors[name]}
        >
          <MenuItem value="">{label}</MenuItem>
          {options &&
            options.map((option) => (
              <MenuItem key={option.revVal2} value={option.revVal2}>
                {option.revVal1}
              </MenuItem>
            ))}
        </TextField>
      ) : (
        <>
          <React.Fragment>
            {loading ? <CircularProgress color="inherit" size={20} /> : null}
          </React.Fragment>
        </>
      )}
    </>
  );
};

export default React.memo(SearchCodeSelectbox);
